module.exports = __webpack_public_path__ + "static/media/10-metros-pt-br-horizontal.6993995c.svg";